module.exports = __webpack_public_path__ + "static/media/ips-incoming.a78b5fdd.svg";